export default "__VITE_ASSET__Cug6oohp__"